/* eslint-disable react/prop-types */ // because I can't be bothered with fixing this too. someone else do it
import React, { Component } from "react";
import Avatar from "@material-ui/core/Avatar";
// import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
// import LockIcon from "@material-ui/icons/LockOutlined";
import { ReactComponent as LockIcon } from "@app/assets/svgs/Lock.svg";
import Paper from "@material-ui/core/Paper";
// import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
// import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { Link } from "react-router-dom";
import { checkResetTokenValid as checkResetTokenValidPromise, passwordReset as passwordResetPromise } from "../api";
import FullScreenLoading from "@app/common/components/FullScreenLoad";
import { CircularProgress } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import commonWords from "@app/common/data/DjangoCommonPasswords";
import { setUser, trackEvent } from "@amplio-common/analytics";
import CommonButton from "@app/common/components/material_ui/Button";
import { Trans } from "@lingui/macro";
import { css } from "@emotion/react";
import PasswordValidate from "./password-validate";
import SupportDetails from "@app/common/components/SupportDetails";
import StreamlineIconWrapper from "@app/common/components/StreamlineIconWrapper";
import { PASSWORD_MIN_LENGTH, PASSWORD_COMPLEXITY_REG_EXP } from "../constants";
// import { isMobileOnly } from "react-device-detect";

const rootStyle = theme => css`
  .MuiInputBase-root{
    font-family: ${theme.typography.fontFamily} !important;
  }
  .MuiFormLabel-root{
    font-family: ${theme.typography.fontFamily};
  }
  .MuiPaper-rounded {
      border-radius: 16px;
  }
  .MuiInputAdornment-root {
    cursor: pointer;
    color: #666;
  }
  .MuiFormControl-marginNormal {
      margin: max(1vh, 8px) 0;
  }
  .MuiAvatar-root{
    > span > svg > path{
      stroke: ${theme.colors.lightText};
    }
  }
  .h6{
    color: ${theme.colors.text.main};
  }
  .body1{
    span {
      font-family: ${theme.typography.fontFamily};
    }
  }
  .buttonWrapper{
    padding-bottom: 16px;
  }
  .buttonWrapper.resend{
    margin-bottom: 24px;
    margin-top: 18px;
  }
  .body1-resend-text-wrapper,
  .body1-invalid-link{
    padding-top: 16px;
    padding-bottom: 16px;
  }
  /* .user-name-input >input:first-of-type{
    color:red;
    font-weight: bold;
    font-size: 1.2em;
  } */
`;

const styles = theme => ({
  main: {
    fontFamily: "Lexend",
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 488,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(0)}px ${theme.spacing(3)}px`,
  },
  avatar: {
    margin: theme.spacing(),
    backgroundColor: "#F1F6FD",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(),
  },
  resetPasswordBottom: {
    paddingBottom: `${theme.spacing(2)}px`,
  },
});

class PasswordResetComponent extends Component {
  constructor(props) {
    super(props);
    const { uuid, token } = this.props.match.params;
    this.uuid = uuid;
    this.token = token;
    this.new_pwd = React.createRef();
    this.re_new_pwd = React.createRef();
    // this.isMobile = isMobileOnly;
    this.state = {
      isLoadingCheck: true,
      isLoadingReset: false,
      isTokenValid: false,
      email: "",
      resentToken: false,
      stateErr: null,
      passwordSetSuccess: false,
      isShowNewPassword: false,
      isShowNewPasswordConfirm: false,
      newPassword: "",
      newPasswordConfirm: "",
      username: "",
    };
  }

  componentDidMount() {
    this.handleAnalyticsReport();
    this.checkResetTokenValid();
  }

  checkResetTokenValid = () => {
    const { uuid, token } = this;
    this.setState({ isLoadingCheck: true });
    checkResetTokenValidPromise(uuid, token).then((r) => {
      const { is_valid, email, id, username /*phone*/ } = r.response;

      this.setState({ isTokenValid: is_valid, email, username /*id, phone*/ });

      if (is_valid) {
        setUser(id);
      }
    }).catch(e => {
      this.setState({ isTokenValid: false });
      console.error(e);
    }).finally(() => setTimeout(() => this.setState({ isLoadingCheck: false }), 1500));
  }

  handleAnalyticsReport = () => {
    const requestParams = new URLSearchParams(this.props.history.location.search);
    const source = requestParams.get("sentBy");

    trackEvent("notification_transfer", { referr_type: source });
  }

  sendNewToken = () => {
    this.props.password(this.state.email);
    this.setState({ resentToken: true });
  }

  _handleSubmit = (e) => {
    // const { uuid, token } = this;
    e.preventDefault();

    trackEvent("create_new_password");
    this.setState({ isLoadingReset: true, stateErr: null });
    passwordResetPromise(this.new_pwd.current.value, this.re_new_pwd.current.value, this.uuid, this.token).then(
      () => {
        this.setState({ passwordSetSuccess: true });
      },
    ).catch((err) => {
      this.setState({ stateErr: err && err.new_password ? err.new_password : ["An error has occureds"] });
      console.error(err);
    }).finally(
      () => this.setState({ isLoadingReset: false }),
    );
  }

  backToLogin = () => {
    trackEvent("back_to_login");
    this.props.history.push("/login");
  }

  render() {
    const { classes, errors } = this.props;
    const { isLoadingCheck, isTokenValid, email, resentToken, isLoadingReset, stateErr,
      passwordSetSuccess, isShowNewPassword, isShowNewPasswordConfirm, newPassword, newPasswordConfirm, username } = this.state;

    if (isLoadingCheck) {
      return <FullScreenLoading />;
    }

    let ErrorMessage = null;
    if (errors) {
      ErrorMessage = errors.map((errorMessage, index) => (
        <div key={`err-${index + 1}`} style={{ color: "red", textAlign: "center" }}>
          {errorMessage}
        </div>
      ));
    }
    if (stateErr) {
      ErrorMessage = stateErr.map((errorMessage, index) => (
        <div key={`state-err${index + 1}`} style={{ color: "red", textAlign: "center" }}>
          {errorMessage}
        </div>
      ));
    }

    if (passwordSetSuccess) {
      return (
        <main className={classes.main} css={rootStyle}>
          <CssBaseline />
          <Paper className={`${classes.paper}  ${classes.resetPasswordBottom}`}>
            <Avatar className={classes.avatar}>
              <StreamlineIconWrapper><LockIcon /></StreamlineIconWrapper>
            </Avatar>
            <div className="h6">
              <Trans>Set a New Password</Trans>
            </div>
            <br /><br />
            <div className="body1 body1-resend-text-wrapper">
              <Trans>Password changed successfully</Trans>
            </div>
            {/* <Button fullWidth variant="contained" color="primary" className={classes.submit} disabled>
              --PLACEHOLDER - BTN TO ENTER SYSTEM (AUTO LOGIN)--
            </Button> */}
            {/*<Button component={Link} to="/login" className={classes.button} onClick={this.goto}>*/}
            {/* { this.isMobile ? (
              <span style={{ fontWeight: "bold", textAlign: "center", padding: "5px", color: "red" }}>To log in with your new password please browse using desktop/tablet devices.</span>
            ) : ( */}
            {/* <Button className={classes.button} onClick={this.backToLogin}>
              <KeyboardBackspaceIcon className={classes.leftIcon} />
              <Trans>Log In With Your New Password</Trans>
            </Button> */}
            <div className="buttonWrapper">
              <CommonButton
                type="button"
                fullWidth
                size="medium"
                variant="contained"
                color="primary"
                onClick={this.backToLogin}
                className={classes.submit}
              >
                <Trans>Log in with your new password</Trans>
              </CommonButton>
            </div>
            {/* )} */}
          </Paper>
        </main>
      );
    }

    if (resentToken) {
      return (
        <main className={classes.main} css={rootStyle}>
          <CssBaseline />
          <Paper className={`${classes.paper}  ${classes.resetPasswordBottom}`}>
            <Avatar className={classes.avatar}>
              <StreamlineIconWrapper><LockIcon /></StreamlineIconWrapper>
            </Avatar>
            <div className="h6">
              <Trans>Set a New Password</Trans>
            </div>
            {/* <br /><br /> */}
            <div className="body1 body1-resend-text-wrapper">
              <Trans>Check your phone or inbox for a new password-reset notification.</Trans>
            </div>
            {/* <Button component={Link} to="/login" className={classes.button}>
              <KeyboardBackspaceIcon className={classes.leftIcon} />
              <Trans>ign in--</Trans>
            </Button> */}
          </Paper>
        </main>
      );
    }

    const isOkPW = newPassword && newPassword.length >= PASSWORD_MIN_LENGTH
      && newPassword.match(PASSWORD_COMPLEXITY_REG_EXP)
      && !commonWords.includes(newPassword)
      && newPasswordConfirm && newPassword === newPasswordConfirm;

    return (
      <main className={classes.main} css={rootStyle}>
        {/* <Button className={classes.button} onClick={this.backToLogin}>
          <KeyboardBackspaceIcon className={classes.leftIcon} />
          <Trans>Log In With Your New Password</Trans>
        </Button> */}

        <CssBaseline />
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <StreamlineIconWrapper><LockIcon /></StreamlineIconWrapper>
          </Avatar>

          { !isTokenValid && email && (
            <>
              <div className="h6" style={{ textAlign: "center" }}>
                <Trans>Invalid Link</Trans>
              </div>
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Typography component="h1" variant="h5">
                  <Trans>Invalid Link</Trans>
                </Typography> */}

                </div>
                <div className="body1 body1-invalid-link" style={{ textAlign: "center", color: "#0F1140" }}>
                  <Trans>The link is no longer valid.</Trans>
                  <br />
                  <Trans>Click below to send a password-reset notification to your phone/email</Trans>
                </div>
                <div>
                  {/* <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={this.sendNewToken}>
                    <Trans>Resend Notification</Trans>
                </Button> */}
                  <div className="buttonWrapper resend">
                    <CommonButton
                      type="button"
                      fullWidth
                      size="large"
                      variant="contained"
                      color="primary"
                      onClick={this.sendNewToken}
                      className={classes.submit}
                    >
                      {/* <KeyboardBackspaceIcon className={classes.leftIcon} /> */}
                      <Trans>Resend notification</Trans>
                    </CommonButton>
                  </div>
                </div>
                <div>
                  <SupportDetails showEmail={false} pageName="reset request" />
                </div>
              </div>
            </>
          )}
          { !isTokenValid && !email && (
            <div>
              <Trans>The link is no longer valid.</Trans>
              <br />
              {/* <Button component={Link} to="/home" fullWidth variant="contained" color="primary" className={classes.submit}>
                <Trans>Back to Login</Trans>
              </Button> */}
              <Link to="/home" onClick={() => { }}>
                <Trans>Back to login</Trans>
              </Link>
              <SupportDetails showEmail={false} pageName="reset request" />
            </div>
          )}
          { isTokenValid && (
            <>
              <div className="h6">
                <Trans>Set a New Password</Trans>
              </div>

              <form className={classes.form} onSubmit={this._handleSubmit}>

                <FormControl margin="normal" required fullWidth>
                  <InputLabel htmlFor="email">
                    <Trans>Username</Trans>
                  </InputLabel>

                  <Input
                    className="user-name-input"
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="off"
                    autoFocus
                    readOnly
                    disabled
                    value={username || email}
                    classes={classes.button}
                  />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel htmlFor="new_password">
                    <Trans>New Password</Trans>
                  </InputLabel>
                  <Input
                    id="new_password"
                    inputRef={this.new_pwd}
                    name="new_password"
                    type={isShowNewPassword ? "text" : "password"}
                    autoComplete="off"
                    onChange={(e) => this.setState({ newPassword: e.target.value })}
                    autoFocus
                    endAdornment={(
                      <InputAdornment position="end" onClick={() => this.setState({ isShowNewPassword: !isShowNewPassword })}>
                        {isShowNewPassword ? <Visibility size={10} /> : <VisibilityOff size={10} />}
                      </InputAdornment>
                      )}
                  />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel htmlFor="re_new_password">
                    <Trans>Re-type New Password</Trans>
                  </InputLabel>
                  <Input
                    id="re_new_password"
                    inputRef={this.re_new_pwd}
                    name="re_new_password"
                    type={isShowNewPasswordConfirm ? "text" : "password"}
                    onChange={(e) => this.setState({ newPasswordConfirm: e.target.value })}
                    autoComplete="off"
                    endAdornment={(
                      <InputAdornment position="end" onClick={() => this.setState({ isShowNewPasswordConfirm: !isShowNewPasswordConfirm })}>
                        {isShowNewPasswordConfirm ? <Visibility size={10} /> : <VisibilityOff size={10} />}
                      </InputAdornment>
                      )}
                  />
                </FormControl>
                {ErrorMessage}
                <div>
                  <br />
                  <PasswordValidate password={newPassword} passwordConfirm={newPasswordConfirm} />
                  <br />
                </div>
                {/* <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} disabled={isLoadingReset || !isOkPW}>
                  {isLoadingReset ? (<CircularProgress size={24} />) : (<FormattedMessage id="auth.password_reset.new_password.save" defaultMessage="Save Password" />)}
                </Button> */}
                <div className="buttonWrapper">
                  <CommonButton
                    type="submit"
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    disabled={isLoadingReset || !isOkPW}
                    className={classes.submit}
                  >
                    {isLoadingReset ? (<CircularProgress size={24} />) : (<Trans>Save password</Trans>)}
                  </CommonButton>
                </div>
                {/* <Button component={Link} to="/login" className={classes.button}>
                  <KeyboardBackspaceIcon className={classes.leftIcon} />
                  <FormattedMessage id="back_to_sign_in" defaultMessage="Back to Sign in" />
                </Button> */}
              </form>
              <SupportDetails showEmail={false} pageName="reset request" />
            </>
          )}

        </Paper>
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PasswordResetComponent);
